import _ from 'lodash'

export default {
	data() {
		return {
			
		}
	},
	props: [],
	created(){
		
	},
	methods: {
		
	},
	computed:{
		getTotalFavoris(){
			return this.$store.getters.getTotalFavoris
		},
	},
	components:{
		
	}
}